import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {SimplePresentation, SimplePresentationRunner} from "../../../core/winpresentation/SimplePresentationRunner";
import {PearlHarbor} from "../../PearlHarbor";
import {PearlHarborFSIntroPresentation} from "../../presentationRunners/freespin/PearlHarborFSIntroPresentation";
import {PearlHarborHelper} from "../../utils/PearlHarborHelper";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {PearlHarborRestoreResizeArea} from "../../presentationRunners/PearlHarborRestoreResizeArea";

export class PearlHarborZeroBetIdlePresentation implements FlowStatePresentation {
    private _flowStateController: FlowStateController;
    private readonly _presentations: SimplePresentation[];

    constructor() {
        this._presentations = [
            new PearlHarborRestoreResizeArea(),
            new PearlHarborFSIntroPresentation()
        ]
    }

    start(flowStateController: FlowStateController): void {
        this._flowStateController = flowStateController;
       if(PearlHarbor.model.isRestore){
           if(PearlHarbor.model.initData.accumulatedRoundWin>0){
               SlotGame.keypadPlugin.setWin(PearlHarbor.model.initData.accumulatedRoundWin, true, PearlHarborHelper.isWinBelowStake());
           }
           PearlHarbor.scatterCounter.restore();
           PearlHarbor.multiplier.restore();

           SimplePresentationRunner.run(this._presentations, () => this.complete(), (callback?: Function) => flowStateController.setSkipCallback(callback));
       }else{
          this.complete();
       }
    }

    public complete() {
        // #148, #173, #194, #248
        if(!PearlHarbor.model.dogfight){
            debugger;
        }
        PearlHarbor.cocpitBoard.updateSpinLeftCount();
        SlotGame.keypadPlugin.setZeroBetSpinCounter(PearlHarbor.model.dogfight.spinsLeft - 1);
        SlotGame.apiPlugin.betHandler.zeroBet();
        this._flowStateController.finish();
    }
}